import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';
import { EqualizerSharp, InsertLinkSharp, StorefrontSharp } from '@mui/icons-material';
import {
  AppBar,
  CssBaseline,
  Divider,
  Drawer,
  Hidden,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material';
import ProductAssociationsTable from './ProductAssociationsTable';
import useStyles from './styles';
import Products from './Products';
import Importer from './Importer';

export default function AdminDrawer({ window }) {
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [activeView, setActiveView] = useState('dashboard');

  const separatedTabs = [
    {
      primary: 'fileImporter',
      name: 'File Importer',
      icon: <InboxIcon />,
    },
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleViewChangeClick = (view) => {
    setActiveView(view);
  };

  const displayView = () => {
    switch (activeView) {
      case 'products':
        return <Products />;
      case 'associations':
        return <ProductAssociationsTable />;
      case 'fileImporter':
        return <Importer />;
      default:
        return (
          <Typography paragraph>
            Overview of most important things
          </Typography>
        );
    }
  };

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <Divider />
      <List>
        <ListItem button onClick={() => handleViewChangeClick('dashboard')}>
          <ListItemIcon>
            <EqualizerSharp />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>

        <ListItem button onClick={() => handleViewChangeClick('products')}>
          <ListItemIcon>
            <StorefrontSharp />
          </ListItemIcon>
          <ListItemText primary="Products" />
        </ListItem>

        <ListItem button onClick={() => handleViewChangeClick('associations')}>
          <ListItemIcon>
            <InsertLinkSharp />
          </ListItemIcon>
          <ListItemText primary="Associations" />
        </ListItem>
      </List>
      <Divider />
      <List>
        {separatedTabs.map((tab) => (
          <ListItem button key={tab.name} onClick={() => handleViewChangeClick(tab.primary)}>
            <ListItemIcon>{tab.icon}</ListItemIcon>
            <ListItemText primary={tab.name} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="secondary"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap className={classes.bookmark}>
            {activeView}
          </Typography>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden mdDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {displayView()}
      </main>
    </div>
  );
}

AdminDrawer.defaultProps = undefined;

AdminDrawer.propTypes = {
  window: PropTypes.instanceOf(Element),
};
